// extracted by mini-css-extract-plugin
module.exports = {"CountryCurrencySwitcher":"styles_CountryCurrencySwitcher__a38qJ","flagIcon":"styles_flagIcon__ItmTs"};